import forEach from 'lodash/forEach'
import isArray from 'lodash/isArray'
import isString from 'lodash/isString'

export type Tactic = Record<string, string> | null

export function parseTacticList(tactic: any): Tactic {
  if (!tactic) {
    return null
  }

  if (!isArray(tactic)) {
    return null
  }

  const result: NonNullable<Tactic> = {}
  let withMatch = false

  forEach(tactic, (item) => {
    if (!isString(item)) {
      return
    }

    const [key, value] = item.split(':', 2)
    result[key] = value
    withMatch = true
  })

  if (!withMatch) {
    return null
  }

  return result
}
